var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"70vh","display":"flex","align-items":"center"}},[_c('div',{staticStyle:{"font-size":"27px","text-align":"center","line-height":"36px","font-style":"oblique"}},[_c('div',[_vm._v(_vm._s(_vm.board))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }